<template>
  <div class="block-wrap block-specification-list" style="padding-top: 8px">
    <div class="sku-batch-row">
      <template v-for="(sname, sindex) in specificationNames">
        <div
          class="sku-batch-item"
          v-if="sname.name"
          :key="sname.name + sindex"
        >
          <div class="sku-batch-item_label">{{ sname.name }}：</div>
          <el-select
            style="width: 80px"
            placeholder="全部"
            :clearable="true"
            v-model="skuBatchUpdateForm[sindex]"
          >
            <el-option
              v-for="item in specifications[sindex].values"
              :key="sname.name + sindex + item.value"
              :label="item.value"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </template>
    </div>
    <div class="sku-batch-row">
      <div
        v-for="(name, key) in skuBatchUpdateLabels"
        :key="key"
        class="sku-batch-item"
      >
        <div class="sku-batch-item_label">{{ name.label }}：</div>

        <el-input-digit
          v-if="name.input.type === 'number'"
          v-model.number="skuBatchUpdateForm[key]"
          style="width: 80px"
          :nullable="true"
          v-bind="name.input.attrs"
        />
        <el-input
          v-else
          v-model="skuBatchUpdateForm[key]"
          style="width: 80px"
          v-bind="name.input.attrs"
        >
        </el-input>
      </div>
      <div class="sku-batch-item">
        <el-button @click="skuBatch">批量设置</el-button>
        <el-button v-if="erpStockImport" @click="erpStockClick"
          >填充erp库存</el-button
        >
      </div>
    </div>

    <el-table
      :height="computedHeight"
      :cell-class-name="getCellClass"
      :span-method="arraySpanMethod"
      :stripe="false"
      ref="skuTable"
      :data="list"
    >
      <template v-for="(item, index) in specificationNames">
        <el-table-column
          :key="specifications[index].name + index"
          :label="specifications[index].name"
          v-if="item.name"
          width="100"
        >
          <template slot-scope="{ row }">
            {{
              row[skuSpecificationsKey][index] &&
              row[skuSpecificationsKey][index].value
            }} </template
          >a
        </el-table-column>
      </template>
      <el-table-column prop="imageUrl" label="预览图" width="100">
        <template slot-scope="{ row }">
          <template v-if="row.disabled">
            <span>铺货时系统自动补全</span>
          </template>
          <div v-else style="margin: 14px 0px 5px">
            <ImgUpload
              :width="46"
              :height="46"
              :onlyPreview="imgOnlyPreview"
              :file="
                row[skuSpecificationsKey][0]
                  ? row[skuSpecificationsKey][0].imageUrl
                  : ''
              "
              @upload-success="
                (url) => (row[skuSpecificationsKey][0].imageUrl = url)
              "
              @del="() => (row[skuSpecificationsKey][0].imageUrl = '')"
              :isSingle="true"
              :limitSuffix="imgLimitSuffix"
              :uploadFunc="uploadFunc"
            />
          </div>
        </template>
        <template v-if="isPdd" slot="header">
          <span style="color: red">*</span>预览图
        </template>
      </el-table-column>
      <el-table-column
        v-for="col in tableCols"
        :key="col.prop"
        :prop="col.prop"
        v-bind="col.attrs"
      >
        <template slot="header">
          <template v-if="col.headerSlot">
            <slot :name="col.prop + 'HeaderSlot'"></slot>
          </template>
          <template v-else>
            <span v-if="!col.attrs.noRequired" style="color: red">*</span
            >{{ col.attrs.label }}
          </template>
        </template>
        <template slot-scope="scope">
          <template v-if="col.input">
            <template v-if="col.input.type === 'number'">
              <el-form-item v-if="isPdd" :error="scope.row[`${col.prop}Error`]">
                <el-input-digit
                  v-model.number="scope.row[col.prop]"
                  :nullable="true"
                  v-bind="col.input.attrs"
                  @input="onInput(scope.row, col.prop, scope)"
                  @blur="onInput(scope.row, col.prop, scope)"
                />
              </el-form-item>
              <el-input-digit
                v-else
                v-model.number="scope.row[col.prop]"
                :nullable="true"
                v-bind="col.input.attrs"
              />
            </template>
            <template v-else-if="col.input.type === 'text'">
              <el-form-item v-if="isPdd" :error="scope.row[`${col.prop}Error`]">
                <el-input
                  v-model="scope.row[col.prop]"
                  @input="onInput(scope.row, col.prop, scope)"
                  @blur="onInput(scope.row, col.prop, scope)"
                  v-bind="col.input.attrs"
                >
                </el-input>
              </el-form-item>
            </template>
            <span v-else>{{ scope.row[col.prop] }}</span>
          </template>
          <template v-else>
            {{ col.format ? col.format(scope.row) : scope.row[col.prop] }}
          </template>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import ImgUpload from "@/components/Uploads/ImgUpload";
import { getErpStock } from "@/servers/prod/center/index.js";
import { getExist } from "../../utils";

export default {
  model: {
    prop: "list",
    event: "change",
  },
  components: {
    ImgUpload,
  },
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    specifications: {
      type: Array,
      default() {
        return [];
      },
    },
    skuSpecificationsKey: {
      type: String,
      default: "skuSpecifications",
    },
    tableCols: {
      // {prop: "price", attrs: {label: '价格', width: "90px"}, input: {type: 'number', attrs: {precision: 2}}}
      type: Array,
      default() {
        return [];
      },
    },
    selectSpecList: {
      type: Array,
      default() {
        return [];
      },
    },
    imgLimitSuffix: {
      // 图片类型限制
      type: String,
      default: ".jpg,.jpeg,.png,.gif",
    },
    imgOnlyPreview: {
      // 图片是否只能预览
      type: Boolean,
      default: true,
    },
    uploadFunc: {
      type: Function,
    },
    isPdd: {
      type: Boolean,
      default: false,
    },
    erpStockImport: {
      // 是否支持erp库存一键填充
      type: Boolean,
      default: false,
    },
    outerId: {
      // 商品款式编码
      type: String,
      default: "",
    },
    specNum: {
      type: Number,
      default: 0,
    },
    noteItemLen: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      skuBatchUpdateForm: {},
      valueForm: {},
    };
  },
  computed: {
    specificationNames() {
      return this.specifications.map((item) => ({ name: item.name }));
    },
    skuBatchUpdateLabels() {
      let labels = {};
      this.tableCols.forEach((item) => {
        if (item.input && !item.input.onlyTable) {
          labels[item.prop] = { label: item.attrs.label, input: item.input };
        }
      });
      return labels;
    },
    computedValueForm() {
      let form = {};
      this.tableCols.forEach((item) => {
        if (item.input) {
          form[item.prop] = "";
        }
      });
      return form;
    },
    computedHeight() {
      // if (this.list.length) {
      //   return ~~(this.list.length * 60) + 'px'
      // } else {
      //   return '58px'
      // }
      return "300px";
    },
  },
  watch: {},
  methods: {
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      return [1, 1]
      const isExist = getExist(this.selectSpecList, row);
      if (!isExist) {
        row.disabled = true;
        if (this.specifications.length === 1) {
          if (columnIndex === 0) {
            return [1, 1];
          } else if (columnIndex === 1) {
            return [1, 6];
          } else if (columnIndex > 1) {
            return [0, 0];
          }
        } else {
          if (columnIndex <= 1) {
            return [1, 1];
          } else if (columnIndex === 2) {
            return [1, 6];
          } else if (columnIndex > 2) {
            return [0, 0];
          }
        }
      } else {
        row.disabled = false;
      }
    },
    initSkuBatchUpdateForm() {
      const spNamesForm = {};
      this.specificationNames.forEach((item, index) => {
        spNamesForm[index] = "";
      });

      this.skuBatchUpdateForm = {
        ...spNamesForm,
        ...JSON.parse(JSON.stringify(this.computedValueForm)),
      };
    },
    // 批量设置
    skuBatch() {
      // 批量设置中没有一项填了值就跳出
      let allNotInput = true;
      Object.keys(this.skuBatchUpdateLabels).forEach((key) => {
        if (
          this.skuBatchUpdateForm[key] ||
          this.skuBatchUpdateForm[key] === 0
        ) {
          allNotInput = false;
        }
      });
      if (allNotInput) return;

      // 判断是不是所有规格都要批处理
      let all = true;
      this.specificationNames.forEach((item, index) => {
        if (!all) return;
        if (this.skuBatchUpdateForm[index]) {
          all = false;
        }
      });

      // 生成当前所选的规格值 未选补全*号
      const selected = this.specificationNames.map((item, index) => {
        return this.skuBatchUpdateForm[index]
          ? this.skuBatchUpdateForm[index]
          : "*";
      });

      const _skuList = this.list.map((item) => {
        const _c_arr = item[this.skuSpecificationsKey].map(
          (item) => item.value
        );
        let matched = true;
        _c_arr.forEach((c, cindex) => {
          if (selected[cindex] !== "*" && selected[cindex] !== c) {
            matched = false;
          }
        });
        if (!matched) return item;

        const newData = {};
        Object.keys(this.skuBatchUpdateLabels).forEach((key) => {
          if (this.skuBatchUpdateForm[key] === 0) {
            newData[key] = 0;
            return;
          }

          if (this.skuBatchUpdateForm[key]) {
            newData[key] = this.skuBatchUpdateForm[key] || item[key] || "";
          }
        });

        return {
          ...item,
          ...newData,
        };
      });
      this.$emit("change", _skuList);
      this.$nextTick(() => {
        this.$emit("validateSkuRows");
      });
    },
    // erp库存一键填充
    async erpStockClick() {
      const res = await getErpStock({ mainOuterId: this.outerId });
      if (res) {
        this.list.forEach((item) => {
          const erpStockItem = res.find(
            (r) => r.erpSysSkuId === `${item.erpSysSkuId}`
          );
          if (erpStockItem) {
            item.stock = erpStockItem.stock <= 0 ? 0 : erpStockItem.stock;
          } else {
            item.stock = 0;
          }
        });
        this.$message.success("填充成功");
      } else {
        this.$message.error("填充失败");
      }
      if (this.isPdd) {
        this.$emit("validateSkuPrices"); // 校验拼单价和单买价
      }
    },
    getCellClass({ row, column }) {
      if (this.isPdd) {
        const props = this.tableCols
          .filter((col) => !!col.input)
          .map((col) => col.prop);
        if (props.indexOf(column.property) !== -1) {
          return "pdd-cell";
        }
        if (row.disabled && column.property === "imageUrl") {
          return "disabled-img-cell";
        }
      }
      return "";
    },
    onInput(row, field, scope) {
      this.$emit("validateSkuRow", row, field, scope);
    },
  },
  mounted() {
    this.initSkuBatchUpdateForm();
  },
};
</script>

<style lang="scss" scoped>
.block-wrap {
  border: 1px solid #dcdfe6;
}
.sku-batch-row {
  display: flex;
  flex-wrap: wrap;
  .sku-batch-item {
    display: flex;
    margin-bottom: 8px;
    margin-right: 8px;
    .sku-batch-item_label {
      width: 80px;
      text-align: right;
    }
  }
}
.block-specification-list {
  max-height: 400px;
  overflow-y: auto;
  ::v-deep .pdd-cell .cell {
    overflow: visible;
    padding: 5px;
  }
  ::v-deep .disabled-img-cell {
    background: #f6f6f6 !important;
    text-align: center;
    color: #aeadae;
  }
}
</style>
